import { createFileRoute } from "@tanstack/react-router";

import { BatteryLow } from "/src/routes/settings/Notifications";

export const Route = createFileRoute("/_main/settings/battery_low")({
  component: BatteryLow,
});
